import React from 'react';
import * as S from './styled';

export type Props = React.ComponentPropsWithoutRef<'button'>;

export const IconButton: React.SFC<Props> = ({ children, ...props }) => {
  return <S.IconButton {...props}>{children}</S.IconButton>;
};
